import React from "react";
import { useLang } from "../LanguageContext";

const SERVICE_URL =
  process.env.REACT_APP_FAST_VOTE_URL ||
  "https://fastvote-347621148423.europe-north1.run.app";

function FastVote() {
  const { t } = useLang();
  return (
    <div className="iframe-page">
      <div className="page-section-header">
        <span className="section-label">{t("fastVote.label")}</span>
        <div className="subhead">{t("fastVote.title")}</div>
        <p className="section-intro-inner">{t("fastVote.intro")}</p>
      </div>
      <div className="iframe-container">
        <iframe src={SERVICE_URL} title={t("fastVote.title")} allowFullScreen />
      </div>
    </div>
  );
}

export default FastVote;
